import React from "react";
import { colors } from "../../lib/designTokens";

type ModuleState = "ready" | "loading" | "empty" | "error" | "unavailable";

type ModuleContainerProps = {
  title: React.ReactNode;
  children?: React.ReactNode;
  plain?: boolean;
  state?: ModuleState;
  message?: string;
};

const DEFAULT_MESSAGES: Record<Exclude<ModuleState, "ready">, string> = {
  loading: "Loading…",
  empty: "Not enough data available yet.",
  error: "This module could not load right now.",
  unavailable: "This module is not available for this run yet."
};

const ModuleNotice = ({
  state,
  message
}: {
  state: Exclude<ModuleState, "ready">;
  message?: string;
}) => {
  return (
    <div
      style={{
        padding: "18px 16px",
        borderRadius: 10,
        border: `1px solid ${colors.border}`,
        background: colors.background,
        color: colors.textSecondary,
        fontSize: 14,
        lineHeight: 1.45
      }}
    >
      {message || DEFAULT_MESSAGES[state]}
    </div>
  );
};

const ModuleContainer = ({
  title,
  children,
  plain = false,
  state = "ready",
  message
}: ModuleContainerProps) => {
  const shouldShowState = state !== "ready";

  return (
    <div
      style={{
        background: "white",
        borderRadius: plain ? "0px" : "10px",
        padding: plain ? "0px" : "20px",
        marginBottom: "24px",
        height: "auto",
        minHeight: "unset",
        boxShadow: plain ? "none" : "0 2px 8px rgba(0,0,0,0.06)"
      }}
    >
      {!plain && <h2 style={{ marginBottom: "16px" }}>{title}</h2>}

      {shouldShowState ? (
        <ModuleNotice state={state} message={message} />
      ) : (
        children
      )}
    </div>
  );
};

export default ModuleContainer;